import React from 'react';
import PropTypes from 'prop-types';

export default function ReportCounterTotal({ title, description, value, valueClassName, hint }) {
  return (
    <div className="report-totals">
      <div className="report-total-title">
        {title}
      </div>
      <div className="report-total-description">
        {description}
      </div>
      <div className={`report-total-value-number ${valueClassName}`}>
        {value}
      </div>
      <div className="report-total-description report-total-hint">
        {hint && hint?.length > 0 ? hint : ''}
      </div>
    </div>
  );
}

ReportCounterTotal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  valueClassName: PropTypes.string,
  hint: PropTypes.string,
};

ReportCounterTotal.defaultProps = {
  valueClassName: '',
  hint: '',
};
